if (!customElements.get("collection-links-component")) {
  class CollectionLinksComponent extends HTMLElement {
    constructor() {
      super();
      this.tabLinks = [];
      this.tabImages = [];
      this.onBlockSelect = this.onBlockSelect.bind(this); // ensure correct `this`
    }

    connectedCallback() {
      this.tabLinks = [...this.querySelectorAll('[data-ref="link"]')];
      this.tabImages = [...this.querySelectorAll('[data-ref="collection-links__image"]')];

      if (!this.tabLinks.length || !this.tabImages.length) return;

      this.bindEvents();
      this.setInitialTab();

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      if (window.Shopify && Shopify.designMode) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    bindEvents() {
      this.tabLinks.forEach((link, index) => {
        link.addEventListener('mouseenter', () => this.activateTab(index));
        link.addEventListener('click', (e) => {
          if (window.innerWidth < 768) e.preventDefault();
          this.activateTab(index);
        });
        link.addEventListener('focus', () => {
          this.activateTab(index);
        });
      });
    }

    setInitialTab() {
      const initialIndex = this.tabLinks.findIndex(link => link.getAttribute('aria-selected') === 'true');
      this.activateTab(initialIndex >= 0 ? initialIndex : 0);
    }

    activateTab(index) {
      this.tabLinks.forEach((link, i) => {
        link.setAttribute('aria-selected', i === index ? 'true' : 'false');
        link.setAttribute('tabindex', '0');
      });

      this.tabImages.forEach((img, i) => {
        if (i === index) {
          img.removeAttribute('hidden');
          img.setAttribute('aria-hidden', 'false');
        } else {
          img.setAttribute('hidden', '');
          img.setAttribute('aria-hidden', 'true');
        }
      });
    }

    onBlockSelect(event) {
      const blockId = event.detail?.blockId || event.detail?.block?.id;
      if (!blockId) return;

      const index = this.tabLinks.findIndex(
        link => link.dataset.blockId === blockId
      );

      if (index !== -1) {
        this.activateTab(index);
      }
    }
  }

  customElements.define("collection-links-component", CollectionLinksComponent);
}
